import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getChannel = async () => {
  const { data } = await axios.get(`${api_base_url}/Channel/Channel`);
  return data;
};
export const addChannel = async (newOfficeType) => {
  const { data } = await axios.post(`${api_base_url}/Channel`, {
    ...newOfficeType[0],
  });
  return data;
};
export const updateChannel = async (updatedOfficeType) => {
  const { data } = await axios.put(
    `${api_base_url}/Channel/${updatedOfficeType[0].channelId}`,
    updatedOfficeType[0]
  );
  return data;
};

export const deleteChannel = async (ids) => {
  await axios.delete(`${api_base_url}/Channel/`, {
    data: ids,
  });
};
